import React from "react";
import { Link } from "react-router-dom";

const SideNavigation = props => {
    return (
        <div className="side-nav">
            <div className="side-nav__item">
                <Link className={"side-nav__link " + (props.selected == "tasks" ? "side-nav__link--selected" : "")} to="/C/tasks"><i className="fas fa-tasks icon side-nav__icon"></i> Assigned Tasks</Link>
            </div>
        </div>
    )
}

export default SideNavigation;